import { isPlatformBrowser, NgIf } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TenantDto } from '@picflow/types';
import { getAllRouteData } from 'src/app/lib/get-all-route-data';
import { NotFoundComponent } from '../../../shared/components/not-found/not-found.component';
import { TenantIconLoaderComponent } from '../../components/tenant-icon-loader/tenant-icon-loader.component';

@Component({
  selector: 'app-gallery-not-found-page',
  templateUrl: './gallery-not-found-page.component.html',
  styleUrls: ['./gallery-not-found-page.component.scss'],
  standalone: true,
  imports: [NgIf, NotFoundComponent, TenantIconLoaderComponent],
})
export class GalleryNotFoundPageComponent {
  platformBrowser: boolean;
  tenant: TenantDto;
  constructor(@Inject(PLATFORM_ID) private platformId: string, private route: ActivatedRoute) {
    this.tenant = getAllRouteData(this.route.snapshot).tenant;
    this.platformBrowser = isPlatformBrowser(this.platformId);
  }
}
